import {AfterViewInit, Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import { Inject, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import { GoogleAnalyticsService } from '../google-analytics.service';
import * as $ from 'jquery';
import Panolens from './Panolens.js';
//import * as loadFont from 'three-bmfont-text';
import MyClass from './MyClass';
import UserInterface from './UserInterface';
import Scenes from './Scenes';
import {DomSanitizer} from '@angular/platform-browser';
import {PanotestService} from './panotest.service';


const TWEEN = Panolens.TWEEN;
const PANOLENS = Panolens.PANOLENS;

import * as THREE from 'three';
//import {VgAPI} from 'videogular2/src/core';
import * as _ from 'underscore';
//import {access} from 'fs';


interface Action {
  id: number;
  desc: string;
  active?: boolean;
  activeIncludes?: [string];
  icode?: string;
  completed: boolean;
  required?: boolean;
  mission?: string;
  missionTimer?: number;
  infoSpotId?: string;
  showArrow?: string;
  showMenu?: boolean;
  tipIcon?: string;
  title?: string;
  button?: any;
  buttonLabel?: string;
  targetLoc?: number;
  completeOnInit?: boolean;
  coords?: object;
  url?:string;
  pano?: any;
  label?: string;
}



@Component({
  selector: 'app-panotest',
  templateUrl: './panotest.component.pug',
  styleUrls: ['./panotest.component.sass'],
  encapsulation : ViewEncapsulation.None
})

export class PanotestComponent implements OnInit, AfterViewInit {

  progressElement: any;
  panoSelected: any;  //for devmode and hot swapping panos
  sceneSelected: any;
  actionSelected: any;
  panoPrvBtns: [any];
  advanced: [any];
  //module: any = Router

  menu: any;
  PANO: any;
  panorama1: any;
  panorama2: any;




  public viewer: any;
  title: any;
  paragraph: any;
  logo: any;
  crate: any;
  gal: any;
  panoramaArray: any;
  //api: VgAPI;
  self: any;
  moveFactor = 10;
  currentObj = {
    x: 0,
    y: 0,
    z: 0,
    rot: {x: 0, y: 0, z: 0}
  };

  scene: any; //to keep typescript happy;
  debugNote = '>>REVIEW MODE ON';

  app: any = {
    quit: function () {
      console.log('APP: quit');
    },
    start: function () {
      console.log('APP: start');
    }
  };

  sceneData: [any];
  sceneData1: [any];
  sceneData2: [any];


  game: MyClass;
  ui: UserInterface;
  scenes: Scenes;


  panTimer: any;
  urlQuery:any

  prvPanoElm: any;
  prvPanoData = [];
  mOffset ={x:0, y:0};

  constructor(private route: ActivatedRoute, public panoservice: PanotestService, private gaService: GoogleAnalyticsService) {

    //this.route.params.subscribe( params => console.log(params));

    this.self = this;

    //if(this.getUrlVars()["module"]) this.game.module = this.getUrlVars()["module"];
    this.urlQuery = this.route.snapshot.queryParamMap;

    panoservice.scope = this;
    this.panoservice.game = new MyClass(panoservice, this); //      = new MyClass(1, this);
    this.panoservice.scenes =  new Scenes(panoservice);
    this.panoservice.ui = this.ui = new UserInterface(panoservice);


    /*if (this.urlQuery.get("module")) {
      this.game = new MyClass(Number(this.urlQuery.get("module")), this);
    }else{
      this.game = new MyClass(1, this);
    }
    if (this.urlQuery.get("unlock")) this.game.unlockTopics();
    if (this.urlQuery.get("hoverText")) this.game.showHoverText = true;
    if (this.urlQuery.get("dataDump")) this.game.dataDump = true;*/


    window['myscope'] = this;
    this.initApp();

  }

  onPanoMenuChange(event){
    console.log('DEV:: Change Pano')
    console.log(event);
    let pano = _.findWhere(this.panoservice.scope.panoramaArray, {src: event})
    if(pano) this.panoservice.scope.gotoPano(pano);
  }
  panoPrvChange(idx:number){

  }


  setPrvPano(event: MouseEvent){
    let el = event.target;
    this.panoservice.scope.prvPanoElm = event.target;
    //console.log(event.target.id);
    this.panoservice.scope.mOffset.x = this.panoservice.scope.prvPanoElm.offsetLeft - event.clientX;
    this.panoservice.scope.mOffset.x = this.panoservice.scope.prvPanoElm.offsetTop - event.clientY;
  }

  releasePrvPano(event){
    this.panoservice.scope.prvPanoElm = null;
  }

  movePrvPano(event){
    //record the element ID and location
    if(this.panoservice.scope.prvPanoElm) {
      let mousePosition = {

        x : event.clientX,
        y : event.clientY

      };
      let el = event.target;
      el.style.left  = (mousePosition.x + this.panoservice.scope.mOffset.x) + 'px';
      el.style.top  = (mousePosition.y + this.panoservice.scope.mOffset.y) + 'px';
      console.log(el)
      let i = _.findWhere(this.panoservice.scope.prvPanoData, {id: el.id});
      if (i) {
        //found
      } else {
        this.panoservice.scope.prvPanoData.push({
          id: el.id,
          left: el.style.left,
          top: el.style.top
        });
      }
      console.log(this.panoservice.scope.prvPanoData);
    }
  }

  onSceneChange(event){

    console.log('DEV:: Change Scene ' + event);
    console.log(this.panoservice.scope.scene);
    let s:any = _.findWhere(this.panoservice.scope.scene, {id: Number(event)});
    console.log(s);

    if(s) {

      this.panoservice.scenes.currentScene = s;
      this.panoservice.scope.gotoPano(s.pano);
      this.panoservice.scenes.buildScene();
    }else{
      console.log('DEV::MENU: Scene not found');
    }

  }

  onActionChange(event){
    console.log('DEV:: Change Action ' + event);
   ;
    let s = _.findWhere(this.panoservice.game.getCurrentTopic().interactions, {id: Number(event)});
    console.log(s);

    if(s) {
      this.panoservice.game.currentInteraction = s;
    }else{
      console.log('DEV::MENU: Action not found');
    }
  }

  initApp() {

    //this.scenes = this.panoservice.scenes;

    //this.panoservice.ui = new UserInterface(this, this.scenes, this.game);
    if (this.urlQuery.get("debug")) this.panoservice.ui.debug = true;

  }

  gotoPano(pano: any) {
    console.log('>>>>>>>>>>>>>>GOTO PANO', pano)
    this.panoservice.ui.showHtmlPopup = false;
    this.viewer.setPanorama(pano);

  }


  /*onPlayerReady(api: VgAPI) {
    console.log('Video Player Ready')
    this.api = api;

  }*/

//Monitor the mouse movements for the first user task. Piped in from the Pano
  setCameraCoords(x, y, z) {

    if (this.panoservice.game.topic === 1 && this.panoservice.game.currentInteraction.id === 0 ) {
      this.panoservice.ui.setCameraCoords(x.toFixed(4), y.toFixed(8), z);
        //if (this.panoservice.ui.initialCamCoords)
        //this.game.checkMouseMoves(x.toFixed(4), this.panoservice.ui.initialCamCoords.x, this.scenes.sceneId);
    }else{
      //Work out if they have moved the camera so we can clear the arrow prompts

      if (this.panoservice.game.currentInteraction.showArrow) {
        this.panoservice.ui.setCameraCoords(x.toFixed(4), y.toFixed(8), z);
        if (this.panoservice.ui.initialCamCoords) {
          this.game.checkArrowMouseMove(x.toFixed(4), this.panoservice.ui.initialCamCoords.x);
        }
      }

    }



  }

  ngOnInit() {
  }

  infoClick(idx: number) {
    console.log('INFO CLICK:');
  }



  onLoad(event) {

    console.log('------------------------PANO Loaded', event.target)


  }

  setupCamera(scene) {
    if (scene.lookAtTarget) {

      this.panoservice.ui.lookAtNowAnim(this.panoservice.ui.lookAtTarget, 1);
      this.panoservice.ui.resetInitalCameraCoords();  //might need to move to the fade in event
    }
    if (scene.fov) {
      console.log('Adjust camera FOV ' + scene.fov);
      PANOLENS.clientScope.viewer.camera.fov = scene.fov;
      PANOLENS.clientScope.viewer.camera.updateProjectionMatrix();
    }

  }

  setupPanoListeners(){
    console.log('PANO LENGTH ' + this.panoservice.panoramaArray.length)

    _.each(this.panoservice.panoramaArray, function(p: any, idx) {
      if(p && p.name!='tmp') {
        p.obj = this;
        p.addEventListener('enter', (event) => { this.onEnter(event) });
        p.addEventListener('progress', (event) => {this.onProgress(event)});
        p.addEventListener('load', (event) => {this.onLoad(event)});
        p.addEventListener('leave', (event) => {

            console.log('>>>>LEAVE SCENE<<<<<');
            this.panoservice.scenes.lastScene = event.target;
            console.log('LAST SCENE:', this.panoservice.scenes.lastScene);
          }
        );

        this.viewer.add(p);

      } else {

      }

    }, this);
  }
  removePanoListeners() {
    for (let i = 0; i < this.panoservice.panoramaArray.length; i++) {
      let p: any = this.panoservice.panoramaArray[i];
      if (p.obj) p.obj = null;
      p.removeEventListener('enter', (event) => { this.onEnter(event) });
      p.removeEventListener('progress', (event) => {this.onProgress(event)});
      p.removeEventListener('load', (event) => {this.onLoad(event)});
      p.removeEventListener('leave', function (event) {

        console.log('>>>>LEAVE SCENE<<<<<');
        this.panoservice.scenes.lastScene = event.target;
        console.log('LAST SCENE:', this.panoservice.scenes.lastScene);

        this.dispose();
      });
    }
  }

  //When we enter a PANO
  onEnter(event: any) {
        //Upon loading a Pano, find associated Scene Data and process.

        console.log(' ');
        console.log('ONENTER PANO------------------------------------------->' + this.viewer.panorama.name);

        this.progressElement = document.getElementById('progress');
        this.progressElement.style.width = 0;
        this.progressElement.classList.remove('finish');

    var s: any;

    clearInterval(this.panoservice.ui.panTimer);
    this.panoservice.ui.clearUserMission();

    console.log('TOPIC: '+this.panoservice.game.topic)

    //SCENE DATA IS MATCHED VIA PANOS
    if (this.panoservice.game.topic === 0) {
      s = _.findWhere(this.panoservice.sceneData, {pano: this.scene[0]});
    }

    if (this.panoservice.game.topic == 1) {
      s = _.findWhere(this.panoservice.sceneData1, {id: this.viewer.panorama.sceneId});
    }

    if (s) {
      console.log('Found a scene interactions::', s);
      this.panoservice.scenes.buildScene(s);  //The panorama has the scene already attached
      this.viewer.panorama.addEventListener('enter-fade-start', this.panoservice.scenes.onFadeStart());
      this.viewer.panorama.addEventListener('enter-fade-complete', this.panoservice.scenes.onFadeEnd());

      if (this.panoservice.game.ua.platform == 'iPad') {
        //Don't bother
      } else {


      }


    } else {
      console.log('!!!!!!!! NO SCENE INTERACTIONS FOUND', s);
      //if Menu pan the scene
      if(this.panoservice.game.topic===0)   this.panoservice.ui.panTimer = window.setInterval(this.panoservice.ui.panCamera, 10, this.viewer);
    }

    }

    onPanoEnterHandler(){


    }

    onProgress(event) {

      this.progressElement = document.getElementById('progress');
      let progress = event.progress.loaded / event.progress.total * 100;
      console.log('LOADING ' + progress)
      this.progressElement.style.width = progress + '%';
      if (progress === 100) {
        this.progressElement.classList.add('finish');
      }


  }

  onFontLoaded(ev: any) {
    console.log('onFontLoaded');
    //this.buildPara();

    this.panoservice.game.initCourse(0);

    //START!!!!!!!!!!!!!!

    window.setTimeout(this.panoservice.ui.hideBlocker, 4000);
  }



  rotatePoint(point, center, angle) {

    angle = (angle ) * (Math.PI/180); // Convert to radians

    var rotatedX = Math.cos(angle) * (point.x - center.x) - Math.sin(angle) * (point.y-center.y) + center.x;

    var rotatedY = Math.sin(angle) * (point.x - center.x) + Math.cos(angle) * (point.y - center.y) + center.y;



    return {x:rotatedX, y: rotatedY};

  }

  handleKeys(event: KeyboardEvent) {

    let focusElem: any = document.activeElement;

    let e = event;

    if (focusElem) {

      if (event.keyCode == 9) {
        console.log('TAB MODE');
        document.body.classList.add('user-is-tabbing');
      }

      if (event.keyCode == 13) {
        console.log('KEY ENTER');
        if (focusElem.click) focusElem.click();

        /*if(focusElem.id.indexOf('widget') != -1) {
         if(e.srcElement.focusObj) e.srcElement.focusObj.click()
         }*/
      }
    }

    let f = (e.ctrlKey == true) ? 10 : 2;
    let obj: any = this.panoservice.ui.hoverObject;

    if (this.panoservice.ui.hoverObject) {
      // f=119, b= 115, r= 100, l=97
      this.currentObj.x = obj.position.x;
      this.currentObj.y = obj.position.y;
      this.currentObj.z = obj.position.z;
      this.currentObj.rot.y = obj.rotation.y;



      if (event.key == 'w') this.currentObj.y = this.currentObj.y + (this.moveFactor * f)
      if (event.key == 's') this.currentObj.y = this.currentObj.y - (this.moveFactor * f)

      if (event.key == 'e') this.currentObj.z = this.currentObj.z + (this.moveFactor * f)

      if (event.key == 'd') {
        this.currentObj.x = this.currentObj.x + (this.moveFactor * f)
        //this.currentObj.x = this.currentObj.x * Math.cos(0.5);
        //this.currentObj.z = this.currentObj.z * Math.sin(0.5);

        /*let newCoords:object = this.rotatePoint({x:this.currentObj.x, y: this.currentObj.y},{x:0,y:0},1);
        this.currentObj.x = newCoords.x;
        this.currentObj.y = newCoords.y;*/

      }


      if (event.key == 'a') this.currentObj.x = this.currentObj.x - (this.moveFactor * f)
      if (event.key == 'q') this.currentObj.z = this.currentObj.z - (this.moveFactor * f)

      if (event.key == 'z') this.currentObj.rot.y = this.currentObj.rot.y - ((e.shiftKey == true) ? 1 : 0.1);
      if (event.key == 'c') this.currentObj.rot.y = this.currentObj.rot.y + ((e.shiftKey == true) ? 1 : 0.1);


      //obj.rotation.y = this.currentObj.rot.y;
      obj.position.set(this.currentObj.x, this.currentObj.y, this.currentObj.z);
      console.log(this.moveFactor, f, obj.position, obj.rotation, e.shiftKey);
    }

    // this.paragraph.rotation.y = this.currentObj.rot.y;
    // this.paragraph.position.set( this.currentObj.x, this.currentObj.y, this.currentObj.z );
    // console.log(this.paragraph.position, this.paragraph.rotation);*!/

    // e.stopPropagation();

  }

  onMouseMove(event) {
    var raycaster = new THREE.Raycaster();
    if (this.panoservice.ui.hoverObject) {
      let obj: any = this.panoservice.ui.hoverObject;
      let camera: any = this.panoservice.scope.viewer.camera;
      var mouse = new THREE.Vector3();
      var vec = new THREE.Vector3(); // create once and reuse
      var pos = new THREE.Vector3(); // create once and reuse

      let vPos = new THREE.Vector3();
      let vDir = new THREE.Vector3();
      let vOutPos = new THREE.Vector3();

      vPos.set(
        -1.0 + 2.0 * event.clientX / window.innerWidth,
        -1.0 + 2.0 * event.clientY / window.innerHeight,
        obj.position.z
      ).unproject( camera );

      // Calculate a unit vector from the camera to the projected position
      vDir.copy( vPos ).sub( camera.position ).normalize();

      // Project onto z=0
      let flDistance = -camera.position.z / vDir.z;
      vOutPos.copy( camera.position ).add( vDir.multiplyScalar( flDistance ) );

      console.log(vOutPos)
      console.log(this.panoservice.ui.hoverObject.position)

      // Make the sphere follow the mouse
      /*const vector = new THREE.Vector3(mouse.x, mouse.y, 10000);
            vector.unproject(camera);
      var dir = vector.sub(camera.position)//.normalize();
      //var distance = -camera.position.z / dir.z;
      var distance = -100;
      var pos = camera.position.clone().add(dir.multiplyScalar(distance));
      obj.position.copy(pos);*/
    }
    // Make the sphere follow the mouse
//	mouseMesh.position.set(event.clientX, event.clientY, 0);
  };

  infoSpotClick(infoSpot: any) {

    if (infoSpot) {
      console.log(infoSpot)
      if (infoSpot.clickHandler) {
        console.log('SPOT => CLICK HANDLER');
        infoSpot.clickHandler();
        return
      }
    }
  }

  mouseMoveHover() {
    //mouse move events
  }

  showVideo() {
    //$('#videoPlayer').show();
    console.log("video");
    //var m = this.api.getDefaultMedia();


  }

  restoreWidget(tmp) {

  }

  initViewer() {
    document.addEventListener('keydown', (data) => this.handleKeys(data));

    //let blk = document.getElementById('blocker');
    //$(blk).show();


    this.viewer = new PANOLENS.Viewer({
      container: document.getElementById('panoView'),
      output: 'console',
      horizontalView: false,			// Allow only horizontal camera control
      cameraFov: 100,
      controlBar: true,
      controlButtons: [],
      viewIndicator: true,
      autoHideInfospot: false,
      noKeys: false
    });

    this.viewer.camera.position.set(1, 0, 0);

  }



  initTopic(t: number, sceneId: number = 0) {
    console.log('SCOPE:INIT TOPIC '+this.panoservice.game.topic);
    this.panoservice.ui.showBlocker();
    //this.panoservice.panoramaArray = [];    //COMMENT THIS OUT WHEN NOT USING PANO DROP DOWN
    this.scene = null;

    if (this.panoservice.game.topic == 0) {this.scene = this.panoservice.sceneData;}
    if (this.panoservice.game.topic == 1) {this.scene = this.panoservice.sceneData1;}

    console.log('LOADING TOPIC '+this.panoservice.game.topic);

    if(!this.scene[0].pano) {
      console.log(' ');
      console.log(' ');
      console.log("********* ERROR CANT FIND SCENE topic=" + this.panoservice.game.topic);
      console.log(' ');
      console.log(' ');
    }


    _.each(this.scene, function(s: Action ,i){
      if(s && s.pano){
        console.log(s.desc+ " = src image: "+s.pano.src);
      }

    })

    //this.gotoPano(this.scene[sceneId].pano);  //set to first Pano. Here we'll start at 6 as we only have the one topic
    this.gotoPano(_.findWhere(this.panoservice.panoramaArray,{name: 'Flinders'}))


  }



  ngAfterViewInit() {
    $(document).ready(function () {
      //console.log('--------------------JQuery Ready:PANO');
    });
    //document.addEventListener('mousemove', this.onMouseMove, false);
    // Load font with callback when font is ready
    PANOLENS.clientScope = this;
    //this.panoservice.game = this.game;
    //UI = this.ui;
    //this.panoservice.scenes = this.scenes;



    this.panoservice.ui.showBlocker();
    PANOLENS.Utils.loadBMFont({
      font: 'assets/fnt/Lato-Regular-64.fnt',
      image: 'assets/fnt/lato.png'
    }, ((data) => this.onFontLoaded(data)));


    window.onunload = function () {
      console.log('Window quit...')

      PANOLENS.clientScope.this.panoservice.game.LMS.save();
      PANOLENS.clientScope.this.panoservice.game.LMS.quit();

    }


  }



  location(index: number, label: string, pano: any, coords: object, active: boolean = true, name?: string){
    return {
      img: this.panoservice.ui.toolbar.map, type: 'location', index: index, text: label, active: active, link: {
      pano: pano,
        coords: coords || {x: -820, y: -340, z: 2420},
      size: 200,
        img: this.panoservice.ui.icons.map,
        name: name || 'locLink'
    }
    };
  }


}




